import { scopeThreadRef } from "@cmmd-forge/client-runtime";
import { EnvironmentId, type ScopedThreadRef } from "@cmmd-forge/contracts";

import type { RemoteRuntimeThreadRouteTarget } from "../chat/remoteRuntimeThreadRoute.logic";
import { buildCmmdRuntimeEnvironmentId } from "../../environments/cmmdRuntimeEnvironmentId";

/**
 * Converts a route alias into the durable thread identity held by CMMD's
 * inventory. The route's saved-environment alias remains a fallback for a live
 * thread while Cloud inventory is always keyed by its runtime environment id.
 */
export function projectContentSearchRouteThreadRefs(input: {
  readonly routeThreadRef: ScopedThreadRef | null;
  readonly canonicalEnvironmentId: string | null;
  readonly remoteTarget: RemoteRuntimeThreadRouteTarget | null;
}): readonly ScopedThreadRef[] {
  if (!input.routeThreadRef) return [];
  const threadId = input.routeThreadRef.threadId;
  const refs: ScopedThreadRef[] = [];
  if (input.remoteTarget?.connectionKind === "cloud") {
    refs.push(
      scopeThreadRef(
        EnvironmentId.make(buildCmmdRuntimeEnvironmentId(input.remoteTarget.runtimeId)),
        threadId,
      ),
    );
  }
  if (input.canonicalEnvironmentId) {
    refs.push(scopeThreadRef(EnvironmentId.make(input.canonicalEnvironmentId), threadId));
  }
  refs.push(input.routeThreadRef);
  return refs.filter(
    (ref, index) =>
      refs.findIndex(
        (candidate) =>
          candidate.environmentId === ref.environmentId && candidate.threadId === ref.threadId,
      ) === index,
  );
}
